<template>
  <div>
    <Header></Header>

    <!-- PAGE HEADER -->
    <div class="page-header doacao">
      <div class="container">
        <div class="row">
          <div class="col-md-offset-1 col-md-10 text-center">
            <h1 class="text-uppercase">--</h1>
          </div>
        </div>
      </div>
    </div>
    <!-- /PAGE HEADER -->

    <!-- SECTION -->
    <div class="section">
      <!-- container -->
      <div class="container">
        <!-- row -->
        <div v-if="false" class="row">
          <div class="col-md-12">
            <div class="section-row">
              <div class="section-title">
                <h2 class="title">Ajude-nos a continuar</h2>
              </div>
              <p>
                O Pedline é um projeto sem fins lucrativos, que conta a com a
                colaboração de voluntários.
              </p>

              <p>
                Você pode nos ajudar fazendo uma doação, de qualquer valor, para
                mantermos e ampliarmos este trabalho. Obrigado por sua visita!
              </p>

              <p>
                <b>Como doar?</b>
              </p>

              <p>
                Você pode transferir diretamente qualquer valor para:
                <br />
                <br />
                <b>Sociedade de Medicina e Cirurgia de Campinas</b>.
              </p>

              <p>
                <b>Banco:</b> 033 - Santander
                <br />
                <b>Agência:</b> 0632
                <br />
                <b>C/C:</b> 13005997-7
                <br />
                <b>CNPJ:</b> 46.075.677/0001-90
              </p>

              <p>
                <b>Doar qualquer valor pelo Paypal:</b>
              </p>

              <!-- <a href class="primary-button">PayPal</a> -->
              <form
                action="https://www.paypal.com/cgi-bin/webscr"
                method="post"
                target="_top"
              >
                <input type="hidden" name="cmd" value="_s-xclick" />
                <input
                  type="hidden"
                  name="hosted_button_id"
                  value="WALJZUXZKEAQ2"
                />
                <input
                  type="image"
                  src="https://www.paypalobjects.com/pt_BR/BR/i/btn/btn_donateCC_LG.gif"
                  border="0"
                  name="submit"
                  title="PayPal - The safer, easier way to pay online!"
                  alt="Faça doações com o botão do PayPal"
                />
                <img
                  alt=""
                  border="0"
                  src="https://www.paypal.com/pt_BR/i/scr/pixel.gif"
                  width="1"
                  height="1"
                />
              </form>
            </div>
          </div>
        </div>
        <!-- /row -->
      </div>
      <!-- /container -->
    </div>
    <!-- /SECTION -->

    <Footer></Footer>
  </div>
</template>
<script>
import Header from "../components/Header";
import Footer from "../components/Footer";

export default {
  name: "Doacao",
  components: {
    Header,
    Footer
  }
};
</script>



// WEBPACK FOOTER //
// src/views/Doacao.vue